/* eslint-disable no-unused-vars */
export default {
  dosingEntries: state => state.dosingEntries,
  dosingViewControls: state => (dosingKey) => {
    const temp = state.dosingEntries.find(dosing => dosing._key === dosingKey);
    return temp ? {
      dosageRate: temp.dosageRate,
      gallonsPerDay: temp.gallonsPerDay,
      partsPerMillion: temp.partsPerMillion,
      pumpCycles: temp.pumpCycles,
    } : null;
  },
  dosingRateOrCyclesChanged: state => (dosingKey, stateType) => {
    const temp = state[stateType].find(dosing => dosing._key === dosingKey);
    return temp ? {
      dosageRate: temp.dosageRate,
      pumpCycles: temp.pumpCycles,
    } : null;
  },
  dosingCounterValue: state => (dosingKey, counter) => {
    const temp = state.dosingEntries.find(dosing => dosing._key === dosingKey);
    return temp ? temp[counter] : null;
  },
  dosingCounterRateTypeValue: state => (dosingKey, dosingRateType, counter) => {
    const temp = state.dosingEntries.find(dosing => dosing._key === dosingKey);
    return temp ? temp[dosingRateType][counter] : null;
  },
  dosingHistoryType: state => (dosingKey, historyType) => {
    const temp = state.dosingEntries.find(dosing => dosing._key === dosingKey);
    return temp ? temp.history[historyType] : null;
  },
  dosingRateTypeData: state => (dosingKey, dosingRateType) => {
    const temp = state.dosingEntries.find(dosing => dosing._key === dosingKey);
    return temp ? temp[dosingRateType] : null;
  },
  dosingInjections: state => (dosingKey) => {
    const temp = state.dosingEntries.find(dosing => dosing._key === dosingKey);
    return temp ? temp.injections : null;
  },
  dosingForSave: state => (dosingKey) => {
    const temp = state.dosingEntries.find(dosing => dosing._key === dosingKey);
    return temp ? {
      _key: temp._key,
      name: temp.name,
      dosageRate: temp.dosageRate,
      gallonsPerDay: temp.gallonsPerDay,
      partsPerMillion: temp.partsPerMillion,
      pumpCycles: temp.pumpCycles,
      ppm: temp.ppm,
      gpd: temp.gpd,
      cpm: temp.cpm,
      dpc: temp.dpc,
      flowRateData: temp.flowRateData,
      targetDosingData: temp.targetDosingData,
    } : null;
  },
};
